// import * as VARIABLES from 'common/variables/routers'

const routeArr = [{
  // key: VARIABLES.INDEX,
  key: '/cs/index',
  value: ['首页']
}, {
  // key: VARIABLES.PERMISSION_ADMINISTRATOR_MANAGE,
  key: '/cs/cabinetManage',
  value: ['信息', '试剂柜信息']
}, {
  // key: VARIABLES.PERMISSION_ROLE_GROUP,
  key: '/cs/ParameterInformation',
  value: ['信息', '台账信息']
}, {
  // key: VARIABLES.PERMISSION_MENU,
  key:'/cs/StorageMessage',
  value: ['信息', '储存信息']
}, {
  // key: VARIABLES.USER_COMPANY_MANAGE,
  key:  '/cs/purchaseMessage',
  value: ['信息', '购买信息']
}, {
  // key: VARIABLES.USER_COMPANY_MANAGE,
    key:  '/gs/typingReagents',
    value: ['管理', '手动录入试剂']
},{
    // key: VARIABLES.USER_COMPANY_MANAGE,
    key:  '/gs/excelReagents',
    value: ['管理', 'excel导入试剂']
},{
  // key: VARIABLES.USER_COMPANY_BRAND_MANAGE,
  key:'/gs/findMsds',
  value: ['管理', 'MSDS查询']
}, {
  // key: VARIABLES.EXCHANGE_CHEMISTRY_SELL_MANAGE,
  key: '/gs/useCondition',
  value: ['管理', '购置情况']
}, {
  // key: VARIABLES.EXCHANGE_UNIVERSITY_GOODS_INFO_MANAGE,
    key: '/gs/employCondition',
    value: ['管理', '使用情况']
}, {
    // key: VARIABLES.DICTIONARY_UNIVERSITY_MAINTAIN,
    key:  '/gs/cabinetSet/smartSaid',
    value: ['管理', '试剂柜管理', '智能称管理']
}, {
    // key: VARIABLES.DICTIONARY_UNIVERSITY_MAINTAIN,
    key:  '/gs/cabinetSet/reagentCabinet',
    value: ['管理', '试剂柜管理', '试剂柜管理']
}, {
  // key: VARIABLES.DICTIONARY_COMPANY_JOIN_INFO_MANAGE,
  key: '/gs/laboratory/management',
  value:['管理', '实验室房间管理', '实验室']
}, {
  // key: VARIABLES.NEWS_SYNC_INFO_MANAGE,
  key: '/gs/laboratory/LaboratoryRoom',
  value:['管理', '实验室房间管理', '实验室房间']
}, {
    // key: VARIABLES.NEWS_SYNC_INFO_MANAGE,
    key: '/gs/laboratory/LaboratoryStaff',
    value:['管理', '实验室房间管理', '实验室人员']
}]

export default routeArr
